import React, { Fragment } from 'react'
import { useContext, useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import {  useForm } from "react-hook-form";
import { useNavigate } from "react-router-dom";

import { classNames } from "primereact/utils";
import { Button } from "primereact/button";
import { Tooltip } from 'primereact/tooltip';
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import PrimeTableFooter from '../../components/PrimeTableFooter';
import { FormInput } from '../../components/FormInput';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useOutletContext } from "react-router";
import { checkDpSuccess, getAcct, getCompanyType } from '../../utility/service/tool-service';
import { SystemLoading,checkLoading } from '../../store/loadingStore';
import NoInfo from '../../components/NoInfo';
import { MessageContext,handleSuccessMessage } from '../../store/messageStore';
import { queryTsmpSetting } from '../../utility/service/setting-service';






export const Setting_Index = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const { setItemObj, setAction, currentKeyword,setCurrentKeyword } = useOutletContext();
  const [, loading] = useContext(SystemLoading);
  const [, dispatch] = useContext(MessageContext); //訊息視窗
  const [id ,setId] = useState('');//分頁用
  const [rowData, setRowData] = useState([]);
  const [tooltipTarget, setTooltipTarget] = useState(null);

  const { getValues, setValue, control,clearErrors, register, handleSubmit, formState: { errors,isValid } } = useForm({
    defaultValues: {
      roleSeq: '',
      status: '',
      keyword: ''
    },
     //錯誤驗證時機
    mode: "all"
  })


  const goItemPage = (rowData, action) => {
    setItemObj(rowData);
    setAction(action);
    navigate(action);
  }



  const actionBodyTemplate = (rowData, props) => {
    if (rowData) {
      return (
        <>
          <Button tooltipOptions={{ position: 'top' }} tooltip={t('button.detail')} rounded text severity="secondary" className="p-button-icon-only" onClick={() => { goItemPage(rowData, 'detail') }}>
            <FontAwesomeIcon icon="fa-solid fa-eye" />
          </Button>

        </>

      )

    }
  }

  const valueBodyTemplate = (rowData,props)=>{
    const tooltipContent = rowData?.[props?.field];      
    if(tooltipContent){
      return (
        <span 
          ref={(el) => setTooltipTarget(el)}
          data-pr-tooltip={tooltipContent} 
          data-pr-position="bottom"
          // data-pr-at="right+5 top"
          // data-pr-my="left center-2"
          className="valueBody text-ellipsis" >{tooltipContent}
        </span>
    )
    }
  }




  const onSubmit = (data) => {
    setCurrentKeyword(data?.keywordSearch);
    axios_queryTsmpSetting({ keywordSearch:data.keywordSearch });
  }



  const axios_queryTsmpSetting = (reqBody = {}, readMore = false) => {
    checkLoading(loading)
    queryTsmpSetting(reqBody)
      .then((res) => {
        if (checkDpSuccess(res)) {
          let data = res?.data?.RespBody;
          setId(res.data.RespBody[res.data.RespBody?.length - 1].id)
          if (readMore === true) {
            setRowData((pre) => {
              return [...pre, ...data]
            });
          } else {
            setRowData(data);
          }
        } else { //查無資料
          if (readMore === false) {
            setRowData([]);
          }
        }
      })
      .catch((e) => {
        console.log(e);
      })
      .finally(() => checkLoading(loading, false))
  }

  //查詢更多
  const btnReadMore = () => {
    let reqBody = {
      keywordSearch: getValues("keywordSearch"),
      id: id
    }
    axios_queryTsmpSetting(reqBody, true);
  };





  useEffect(() => {
    if(currentKeyword!==''){
      setValue("keywordSearch",currentKeyword)
    }
    axios_queryTsmpSetting({ keywordSearch:getValues("keywordSearch") });
  }, [])

  return (
    <>
      <div className="p-card bg-gray">
        <div className="p-card-body">
          {/* 上方區塊 */}
          <form className='grid' onSubmit={handleSubmit(onSubmit)}>
            <div className='col-12 lg:col-12'>
              <FormInput
                register={register}
                errors={errors}
                id="keywordSearch"
                name="keywordSearch"
                type="text"
                labelText={t('keyword')}
                labelClass="control-label"
              />
            </div>
            <div className="col-12 gap-2 flex-all-center">
              <Button type="submit" label={t("button.query")} />
            </div>
          </form>
        </div>
      </div>
      {/* 下方 Table */}
      <div className="p-card">
        <div className="p-card-body">

          <DataTable
            stripedRows
            className="white-data-table hover-highlight no-shadow"
            tableStyle={{ minWidth: '55rem' }}
            value={rowData}
            emptyMessage={<NoInfo panel="table" />}
            footer={rowData?.length > 0 && <PrimeTableFooter rowDataList={rowData} isShowMore={true} btnReadMore={btnReadMore} />}

          >
            <Column field="id" header={t('key')} />
            <Column body={valueBodyTemplate} style={{maxWidth:'150px',wordWrap:'break-word'}} field="value" header={t('value')} />
            <Column body={valueBodyTemplate} field="memo" style={{maxWidth:'150px',wordWrap:'break-word'}} header={t('remark')} />
            <Column style={{ width: 'auto' }} body={actionBodyTemplate} header={t('action')} />

          </DataTable>

        </div>
        
      </div>
     {tooltipTarget && <Tooltip mouseTrack  target=".valueBody" position="bottom" event="hover" />} 

      


    </>
  )
}
export default Setting_Index;

